function duplicateRadioText(facet) {
  const radios = facet.querySelectorAll('.facetwp-radio');

  radios.forEach(radio => {
    if (radio.querySelector('.facetwp-duplicate')) return;

    const displayValue = radio.querySelector('.facetwp-display-value');

    let text = '';

    if (displayValue) {
      text = displayValue.textContent.trim();
    } else {
      const textNode = [...radio.childNodes].find(
        node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      );

      if (textNode) {
        text = textNode.textContent.trim();
        const span = document.createElement('span');
        span.textContent = text;
        textNode.replaceWith(span);
      }
    }

    if (!text) return;

    const duplicate = document.createElement('span');
    duplicate.className = 'facetwp-duplicate';
    duplicate.textContent = text;
    radio.appendChild(duplicate);
  });
}

function initFacets() {
  document.querySelectorAll('.facetwp-facet').forEach(duplicateRadioText);
}

document.addEventListener('DOMContentLoaded', initFacets);
document.addEventListener('facetwp-loaded', initFacets);
